const preventDotOnInput = (event) => {
  const { key } = event;
  //   const key = event.which ? event.which : event.keyCode;
  if (key === '-' || key === '+' || key === 'e' || key === '.') {
    event.preventDefault();
  }
};

export default preventDotOnInput;
